window.app = {
	breakpoins: {
		sm: 576,
		md: 800,
		lg: 1024,
		xl: 1199,
	},
};